<template>
  <el-select
    :value="cameraId"
    filterable
    remote
    :size="size"
    placeholder="Поиск по камерам"
    style="width: 100%"
    :loading="loading && !cameras.length"
    :remote-method="remoteMethod"
    @change="change"
  >
    <el-option
      v-for="camera in cameras"
      :key="camera.id_camera"
      :value="camera.id_camera"
      :label="camera.short_name"
    >
      <span style="float: left">{{ camera.short_name }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px; margin-left: 10px">{{ camera.id_camera }}</span>
    </el-option>
    <el-option
      v-if="total && total - cameras.length"
      :value="0"
      disabled
      style="align-items: center; text-align: center"
    >
      <el-button :loading="loading && !queryLoading" type="text" style="width: 100%" size="mini" @click="nextPage">
        {{ loading && !queryLoading ? "Загрузка" : "Показать ещe" }}
      </el-button>
    </el-option>
  </el-select>
</template>

<script>
import { ApiService } from "@/api";

export default {
  name: "SelectCamera",
  model: {
    prop: "camera-id",
    event: "change",
  },
  props: {
    cameraId: {
      type: Number,
      default: null,
    },
    size: {
      type: String,
      default: "small",
    },
  },
  data() {
    return {
      page: 1,
      query: "",
      total: 0,
      queryLoading: false,
      loading: false,
      cameras: [],
    };
  },
  mounted() {
    if (this.cameraId) {
      this.loading = true;
      ApiService.cameras.get(this.cameraId).then((camera) => {
        this.cameras = [camera];
      });
    }
    this.pullCameras(true);
  },
  methods: {
    clearData() {
      this.page = 1;
      this.total = 0;
      this.cameras = [];
    },
    remoteMethod(query) {
      this.queryLoading = true;
      this.query = encodeURI(query);
      this.clearData();
      this.pullCameras().finally(() => {
        this.queryLoading = false;
      });
    },
    nextPage() {
      this.page = this.page + 1;
      this.pullCameras(true);
    },
    pullCameras(update = false) {
      const { page, query: search } = this;

      this.loading = true;
      return ApiService.cameras
        .getList({ search, page, count: 10 })
        .then(({ data: cameras, total }) => {
          this.total = total;
          this.cameras = (update ? [...this.cameras, ...cameras] : cameras).filter((camera, index, array) => {
            return !array.slice(index + 1).find((c) => c.id_camera === camera.id_camera);
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    change(id) {
      const selectedCameras = this.cameras.find((c) => c.id_camera === id);
      this.$emit("change", selectedCameras);
    },
  },
};
</script>
